import React from "react";
import { VideoResult } from "../types";
import { VideoCard } from "./VideoCard";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

interface VideoGridProps {
    videos: VideoResult[];
    loading: boolean;
}

export const VideoGrid: React.FC<VideoGridProps> = ({ videos, loading }) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-32">
                <Loader2 className="w-12 h-12 animate-spin text-primary mb-4" />
                <p className="text-lg font-medium text-muted-foreground animate-pulse">
                    Searching for moments...
                </p>
            </div>
        );
    }

    if (videos.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-32 bg-muted/30 rounded-3xl border border-dashed border-border">
                <p className="text-xl font-medium text-muted-foreground">
                    No videos found
                </p>
                <p className="text-sm text-muted-foreground/70 mt-2">
                    Try adjusting your search terms
                </p>
            </div>
        );
    }

    return (
        <div className="w-full">
            <motion.div
                layout
                className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6"
            >
                {videos.map((video, index) => (
                    <VideoCard
                        key={`${video.filename}-${index}`}
                        video={video}
                    />
                ))}
            </motion.div>
        </div>
    );
};
